export enum CustomGridHeaderBlock {
  Root = 'CustomGridHeader',
}

export enum CustomGridHeaderElement {
  Label = 'label',
}
